import { DEFAULT_CONFIG, SUPPORTED_LOCALES } from "./const"
import type { Locale, SmmAuthConfig } from "./types"
import { resolveBaseUrl, resolveSource } from "./utils"

export { DEFAULT_CONFIG } from "./const"

export const normalizeLocale = (value?: string | null): Locale => {
  const locale = String(value || "").toLowerCase()
  return SUPPORTED_LOCALES.includes(locale as Locale) ? (locale as Locale) : "en"
}

export const findCurrentScript = (): HTMLScriptElement | undefined => {
  if (typeof document === "undefined") return undefined
  const current = document.currentScript
  if (current instanceof HTMLScriptElement) return current
  return undefined
}

export const resolveConfig = (
  script: HTMLScriptElement | undefined = findCurrentScript(),
  overrides: Partial<SmmAuthConfig> = {}
): SmmAuthConfig => {
  const dataset = script?.dataset ?? {}
  const scriptConfig: Partial<SmmAuthConfig> = {
    apiBaseUrl: dataset.apiBaseUrl,
    userCenterUrl: dataset.userCenterUrl,
    cookieName: dataset.cookieName,
    temporaryCookieName: dataset.temporaryCookieName,
    source: dataset.source,
    googleClientId: dataset.googleClientId,
    useRequestIdleCallback: dataset.useRequestIdleCallback === "true",
  }
  const runtimeDefaults: SmmAuthConfig = {
    ...DEFAULT_CONFIG,
    apiBaseUrl: resolveBaseUrl(DEFAULT_CONFIG.apiBaseUrl),
    userCenterUrl: resolveBaseUrl(DEFAULT_CONFIG.userCenterUrl),
    source: resolveSource(),
  }

  return {
    ...runtimeDefaults,
    ...compact(scriptConfig),
    ...compact(overrides),
    source: resolveSource(overrides.source || scriptConfig.source),
  }
}

const compact = <T extends Record<string, unknown>>(value: T): Partial<T> =>
  Object.fromEntries(Object.entries(value).filter(([, v]) => v !== undefined && v !== "")) as Partial<T>
